(function () {
  // The product grid (snippets/collection-grid.liquid) is a legacy
  // float-based layout (.grid--uniform / .grid__item with percentage
  // widths + a negative-margin gutter trick). Switching that container to
  // flexbox/grid to equalize card heights broke the column widths and
  // wrapping, so instead this measures actual rendered rows and sets a
  // matching min-height on each card in that row — the float layout itself
  // is never touched.
  function equalizeHeights(section) {
    var cards = section.querySelectorAll('.grid-product');
    if (!cards.length) return;

    // Reset first so a resize (fewer columns on narrower viewports) can
    // shrink rows back down before re-measuring.
    cards.forEach(function (card) {
      card.style.minHeight = '';
    });

    var rows = [];
    cards.forEach(function (card) {
      var top = Math.round(card.getBoundingClientRect().top);
      var row = rows.find(function (r) {
        return r.top === top;
      });
      if (!row) {
        row = { top: top, cards: [] };
        rows.push(row);
      }
      row.cards.push(card);
    });

    rows.forEach(function (row) {
      var maxHeight = row.cards.reduce(function (max, card) {
        return Math.max(max, card.getBoundingClientRect().height);
      }, 0);
      row.cards.forEach(function (card) {
        card.style.minHeight = maxHeight + 'px';
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-section-type="collection-grid"]').forEach(function (section) {
      var run = function () {
        equalizeHeights(section);
      };

      run();

      // Images finishing (async) shift heights after the initial measure.
      section.querySelectorAll('.grid-product img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', run, { once: true });
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(run, 150);
      });

      // Filtering/sorting/pagination replaces #CollectionAjaxContent's
      // markup via AJAX — re-run whenever that happens.
      var ajaxContent = section.querySelector('#CollectionAjaxContent');
      if (ajaxContent && window.MutationObserver) {
        new MutationObserver(function () {
          run();
          ajaxContent.querySelectorAll('.grid-product img').forEach(function (img) {
            if (img.complete) return;
            img.addEventListener('load', run, { once: true });
          });
        }).observe(ajaxContent, { childList: true, subtree: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
